
import React, { useEffect, useState } from "react";
import TradingSidebar from "./layout/TradingSidebar";

export default function TradingLayout({ children }) {
  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    return localStorage.getItem("trading_sidebar_collapsed") !== "true";
  });

  useEffect(() => {
    localStorage.setItem(
      "trading_sidebar_collapsed",
      sidebarExpanded ? "false" : "true"
    );
  }, [sidebarExpanded]);

  const handleSidebarToggle = (expanded) => {
    setSidebarExpanded(Boolean(expanded));
  };

  const contentStyle = {
    marginLeft: sidebarExpanded ? "260px" : "64px",
    padding: "18px",
    minHeight: "100vh",
    background: "#faf7fb",
    boxSizing: "border-box",
    transition: "margin-left 0.22s ease",
  };

  return (
    <div style={{ minHeight: "100vh" }}>
      <TradingSidebar
        expanded={sidebarExpanded}
        onToggle={handleSidebarToggle}
      />

      <main style={contentStyle}>{children}</main>
    </div>
  );
}
